import { CircularProgress } from '@mui/material';
import React from 'react';
import { LoaderWrapper, LoaderCover } from './Loader.styles';
var Loader = function (props) {
    var type = props.type;
    var renderWrapper = function (spinner) {
        if (type === 'inline') {
            return React.createElement(LoaderWrapper, null, spinner);
        }
        return React.createElement(LoaderCover, null, spinner);
    };
    return renderWrapper(React.createElement(CircularProgress, null));
};
export default Loader;
